import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { useRouter } from 'next/router';
import clipboardCopy from 'clipboard-copy';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CodeBlockContext = /*#__PURE__*/React.createContext({
  current: null
});

/**
 * How to use: spread the handlers to the .MuiCode-root
 *
 * The html structure should be:
 * <div className="MuiCode-root">
 *  <pre>...</pre>
 *  <button className="MuiCode-copy">...</button>
 * </div>
 */
if (false) CodeBlockContext.displayName = "CodeBlockContext";
export function useCodeCopy() {
  var rootNode = React.useContext(CodeBlockContext);
  return {
    onMouseEnter: function onMouseEnter(event) {
      rootNode.current = event.currentTarget;
    },
    onMouseLeave: function onMouseLeave(event) {
      if (rootNode.current === event.currentTarget) {
        var _rootNode$current$que;
        (_rootNode$current$que = rootNode.current.querySelector('.MuiCode-copy')) == null || _rootNode$current$que.blur();
        rootNode.current = null;
      }
    },
    onFocus: function onFocus(event) {
      rootNode.current = event.currentTarget;
    },
    onBlur: function onBlur(event) {
      if (rootNode.current === event.currentTarget) {
        rootNode.current = null;
      }
    }
  };
}
function InitCodeCopy() {
  var rootNode = React.useContext(CodeBlockContext);
  var router = useRouter();
  React.useEffect(function () {
    var key = 'Ctrl + ';
    if (true) {
      var macOS = window.navigator.platform.toUpperCase().includes('MAC');
      if (macOS) {
        key = '⌘';
      }
    }
    var codeRoots = document.getElementsByClassName('MuiCode-root');
    if (codeRoots !== null) {
      var listeners = [];
      Array.from(codeRoots).forEach(function (elm) {
        var handleMouseEnter = function handleMouseEnter() {
          rootNode.current = elm;
        };
        elm.addEventListener('mouseenter', handleMouseEnter);
        listeners.push(function () {
          return elm.removeEventListener('mouseenter', handleMouseEnter);
        });
        var handleMouseLeave = function handleMouseLeave() {
          if (rootNode.current === elm) {
            var _rootNode$current$que2;
            (_rootNode$current$que2 = rootNode.current.querySelector('.MuiCode-copy')) == null || _rootNode$current$que2.blur();
            rootNode.current = null;
          }
        };
        elm.addEventListener('mouseleave', handleMouseLeave);
        listeners.push(function () {
          return elm.removeEventListener('mouseleave', handleMouseLeave);
        });
        var handleFocusin = function handleFocusin() {
          // use `focusin` because it bubbles from the copy button
          rootNode.current = elm;
        };
        elm.addEventListener('focusin', handleFocusin);
        listeners.push(function () {
          return elm.removeEventListener('focusin', handleFocusin);
        });
        var handleFocusout = function handleFocusout() {
          // use `focusout` because it bubbles from the copy button
          if (rootNode.current === elm) {
            rootNode.current = null;
          }
        };
        elm.addEventListener('focusout', handleFocusout);
        listeners.push(function () {
          return elm.removeEventListener('focusout', handleFocusout);
        });
        function handleClick(_x) {
          return _handleClick.apply(this, arguments);
        }
        function _handleClick() {
          _handleClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
            var _event$currentTarget, _textNode$textContent;
            var trigger, pre, textNode;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  trigger = event.currentTarget;
                  pre = (_event$currentTarget = event.currentTarget) == null ? void 0 : _event$currentTarget.previousElementSibling;
                  textNode = trigger.childNodes[0];
                  textNode.nodeValue = ((_textNode$textContent = textNode.textContent) == null ? void 0 : _textNode$textContent.replace('Copy', 'Copied')) || null;
                  trigger.dataset.copied = 'true';
                  setTimeout(function () {
                    if (trigger) {
                      var _textNode$textContent2;
                      textNode.nodeValue = ((_textNode$textContent2 = textNode.textContent) == null ? void 0 : _textNode$textContent2.replace('Copied', 'Copy')) || null;
                      delete trigger.dataset.copied;
                    }
                  }, 2000);
                  _context.prev = 6;
                  if (!pre.textContent) {
                    _context.next = 10;
                    break;
                  }
                  _context.next = 10;
                  return clipboardCopy(pre.textContent);
                case 10:
                  _context.next = 14;
                  break;
                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](6);
                case 14:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[6, 12]]);
          }));
          return _handleClick.apply(this, arguments);
        }
        var btn = elm.querySelector('.MuiCode-copy');
        if (btn) {
          var _btn$querySelector, _keyNode$textContent;
          var keyNode = (_btn$querySelector = btn.querySelector('.MuiCode-copyKeypress')) == null ? void 0 : _btn$querySelector.childNodes[1];
          if (!keyNode) {
            // skip the logic if the btn is not generated from the markdown.
            return;
          }
          keyNode.textContent = (keyNode == null || (_keyNode$textContent = keyNode.textContent) == null ? void 0 : _keyNode$textContent.replace('$key', key)) || null;
          btn.addEventListener('click', handleClick);
          listeners.push(function () {
            return btn.removeEventListener('click', handleClick);
          });
        }
      });
      return function () {
        listeners.forEach(function (removeEventListener) {
          removeEventListener();
        });
      };
    }
    return undefined;
  }, [rootNode, router.pathname]);
  return null;
}
function hasNativeSelection(element) {
  var _window$getSelection;
  if ((_window$getSelection = window.getSelection()) != null && _window$getSelection.toString()) {
    return true;
  }

  // window.getSelection() returns an empty string in Firefox for selections inside a form element.
  // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
  // Instead, we can use element.selectionStart that is only defined on form elements.
  if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) {
    return true;
  }
  return false;
}
/**
 * Place <CodeCopyProvider> at the page level. It will check the keydown event and try to initiate copy click if rootNode exist.
 * Any code block inside the tree can set the rootNode when mouse enter to leverage keyboard copy.
 */
export function CodeCopyProvider(_ref) {
  var children = _ref.children;
  var rootNode = React.useRef(null);
  React.useEffect(function () {
    document.addEventListener('keydown', function (event) {
      if (!rootNode.current) {
        return;
      }

      // Skip if user is highlighting a text.
      if (hasNativeSelection(event.target)) {
        return;
      }

      // Skip if it's not a copy keyboard event
      if (!((event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'C' && !event.shiftKey && !event.altKey)) {
        return;
      }
      var copyBtn = rootNode.current.querySelector('.MuiCode-copy');
      var initialEventAction = copyBtn.getAttribute('data-ga-event-action');
      // update the 'data-ga-event-action' on the button to track keyboard interaction
      copyBtn.dataset.gaEventAction = (initialEventAction == null ? void 0 : initialEventAction.replace('click', 'keyboard')) || 'copy-keyboard';
      copyBtn.click(); // let the GA setup in GoogleAnalytics.js do the job
      copyBtn.dataset.gaEventAction = initialEventAction; // reset the 'data-ga-event-action' back to initial
    });
  }, []);
  return /*#__PURE__*/_jsxs(CodeBlockContext.Provider, {
    value: rootNode,
    children: [/*#__PURE__*/_jsx(InitCodeCopy, {}), children]
  });
}